/**
 * Every path in one place, so a route rename is one edit and a typo is a compile error.
 * `:token` is the opaque session token and is the only credential the app holds.
 */
export const ROUTE_PATHS = {
  entry: '/',
  cashier: '/c/:token',
  notFound: '*',
} as const;

export function cashierPath(token: string): string {
  return `/c/${encodeURIComponent(token)}`;
}
